<template>
  <div class="page_teams">
    <h1>Týmy na ringo</h1>
    <a
      class="exchange"
      href="https://docs.google.com/spreadsheets/d/1Y4CkfN6A4OOtRvQ_8qhphfdbTj-UlbsLoQoWweC5dg8/edit?usp=sharing"
      target="_blank"
    >
      <i class="fas fa-exchange-alt"></i> Burza hráčů
    </a>
    <div class="new">
      <dropdown :items="ringoCategories" @change="change">
        <template v-slot:label>{{ newTeamCategory | cz }}</template>
        <template v-slot:item="props">{{ props.id | cz }}</template>
      </dropdown>
      <button
        class="create"
        :class="{ disabled: isTeamChangeNotAllowed }"
        @click="addTeam"
        title="Vytvořit nový tým"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="registration-end">Možnost změny týmu končí: <strong>{{ config.teamAndRoyRegistrationEndAt | cz }}</strong></div>
    <tabloid name="teams" :columns="columns" :data="myTeams">
      <template v-slot:name="{ row }">{{ row | team_name_full }}</template>
      <template v-slot:capacity="{ value, row }">{{ row.capacityLimit.min }} &lt; <span :class="row.capacityClass">{{ value }}</span> &lt; {{ row.capacityLimit.max }} (+1)</template>
      <template v-slot:members="{ row }">
        <div v-for="(member, participantId) in team_members[row.id]" :key="participantId" class="member">
          <i
            class="fa fa-times"
            :class="{ disabled: isTeamChangeNotAllowed }"
            @click="removePlayer(participantId)"
            title="Odebrat z týmu"
          />
          <span>
            {{ member | participant_name }}
            <i
              v-if="member.playingOutpostId != outpost.id"
              class="fa"
              :class="{ 'fa-check': member.isTeamConfirmed, 'fa-hourglass': !member.isTeamConfirmed }"
              :title="member.isTeamConfirmed ? 'Hrač potvrzen' : 'Čeká na schválení'"
            ></i>
          </span>
        </div>
        <div class="add_group">
          <dropdown
            @change="participant => addPlayer(participant, row.id)"
            :items="row.availablePlayers"
            :disabled="isTeamChangeNotAllowed"
            class="add"
          >
            <template v-slot:label>
              <i class="fas fa-plus"></i>
            </template>
            <template v-slot:item="props">{{ props.item | participant_name }}</template>
          </dropdown>
          <dropdown
            @change="participant => addPlayer(participant, row.id)"
            :items="row.availableForeigners"
            :disabled="isTeamChangeNotAllowed"
            class="addForeigner"
          >
            <template v-slot:label>
              <i class="fas fa-plus"></i> z jiné hlídky
            </template>
            <template v-slot:item="props">{{ props.item | participant_name }}</template>
          </dropdown>
        </div>
      </template>
      <template v-slot:contactPhone="{ row }">
        <inputer name="Kontaktní telefon" :paths="['teams', row.id, 'contactPhone']" />
      </template>
      <template v-slot:actions="{ row }">
        <div class="remove" :class="{ disabled: isTeamChangeNotAllowed }" @click="removeTeam(row.id)">
          <i class="fa fa-times" />
        </div>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { _ } from "../extend";
import tabloid from "../components/tabloid";
import inputer from "../components/inputer";
import dropdown from "../components/dropdown";

export default {
  name: "teams",
  components: {
    tabloid,
    inputer,
    dropdown,
  },
  data: () => ({
    newTeamCategory: "royalRanger_restful",
    selectShowed: false,
    columns: {
      name: { title: "Jméno" },
      capacity: { title: "Kapacita" },
      members: { title: "Členové" },
      contactPhone: { title: "Kontaktní telefon", headerAttributes: { title: "nepovinné" } },
      actions: { title: " " },
    },
  }),
  computed: {
    ...mapState(["outpost", "participants", "categories", "childCategories", "config"]),
    ...mapGetters(["team_members"]),
    ringoCategories() {
      return _.filter(this.categories, category => category.excludeFromRingo == false);
    },
    myTeams() {
      const getCapacityClass = team => {
        if (team.capacity < team.capacityLimit.min || team.capacity > (team.capacityLimit.max + 1))
          return "wrong";
        if (team.capacity == team.capacityLimit.max + 1)
          return "reserve";
        return "right";
      };

      let result = _.filter(this.$store.state.teams, team => team.outpostId == this.$store.state.outpost.id);
      result = _.select(result, t => {
        const team = { ...t };
        const teamCategory = team.id.split("-")[0];
        team.capacityLimit = this.$store.state.categories[teamCategory];
        team.capacity = Object.keys(this.team_members[team.id]).length;
        team.capacityClass = getCapacityClass(team);
        team.members = Object.keys(this.team_members[team.id]).length;
        team.availablePlayers = _.filter(
          this.$store.state.participants,
          participant =>
            participant.playingOutpostId == this.outpost.id &&
            participant.teamId == null &&
            this.$store.state.childCategories[teamCategory].includes(participant.categoryId));
        team.availableForeigners = _.filter(
          this.$store.state.participants,
          participant =>
            participant.playingOutpostId != this.outpost.id &&
            participant.teamId == null &&
            participant.isFree &&
            this.$store.state.childCategories[teamCategory].includes(participant.categoryId));
        return team;
      });

      return result;
    },
    isTeamChangeNotAllowed() {
      return this.$store.state.config.teamAndRoyRegistrationEndAt < new Date();
    },
  },
  methods: {
    addTeam() {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.dispatch("createTeam", {
        categoryId: this.newTeamCategory
      });
    },
    removeTeam(id) {
      if (this.isTeamChangeNotAllowed) return;

      if (confirm("Opravdu chcete smazat celý tým?")) {
        this.$store.commit("removeTeam", { teamId: id });
      }
    },
    addPlayer(participant, teamId) {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.commit("update", {
        paths: ["participants", participant.id, "teamId"],
        value: teamId
      });
    },
    removePlayer(participantId) {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.commit("update", {
        paths: ["participants", participantId, "teamId"],
        value: null
      });
    },
    change(value, key) {
      this.newTeamCategory = key;
      this.selectShowed = false;
    },
  },
  mounted() {
    // team members count
    this.$store.commit("addEventHandler", {
      paths: ["participants", "*", "teamId"],
      id: '30888cbd-3cdf-45ef-b428-d648228d9936',
      action: function (type, actionPaths, value) {
        _.select(this.myTeams, team => {
          var category = this.$store.state.categories[team.id.split("-")[0]];
          var count = Object.keys(this.team_members[team.id]).length;
          var paths = ["teams", team.id];
          var isValid = this.$store.getters.isValidAt(paths);

          // reserve player
          if (value == team.id && count == (category.max + 1)) {
            this.$store.commit("notify", {
              text: `V kategorii ${this.$options.filters.cz(category.id)} mohou být na hřišti maximálně ${category.max} hráči, jeden bude náhradník`,
              level: "warning",
            });
          }

          // valid
          if (category.min <= count && count <= (category.max + 1)) {
            if (!isValid) {
              this.$store.commit("removeValidationError", {
                paths: paths
              });
            }
          }
          // invalid
          else if (isValid) {
            this.$store.commit("addValidationError", {
              paths: paths,
              message: `Špatný počet účastníků u týmu ${this.$options.filters.team_name_full(team)}`
            });
          }
        });
      }.bind(this)
    });
    this.$store.commit("addEventHandler", {
      paths: ["teams", "*"],
      id: 'ba256dc7-96a7-4ea4-95af-77898f9c656a',
      action: function(type, paths) {
        if (type == "add") {
          this.$store.commit("addValidationError", {
            paths: paths,
            message: `Špatný počet účastníků: ${paths[1]}`
          });
        } else if (type == "remove") {
          this.$store.commit("removeValidationError", {
            paths: paths
          });
        }
      }.bind(this)
    });
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.page_teams
  @include table-view()
  grid-template-areas: "label action end link" "table table table table"
  grid-template-columns: auto auto auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .new
    grid-area: action
    display: flex
    .input-select .label
      @include first-input()
    .create
      @include button-primary()
      @include last-input()
      &.disabled
        cursor: not-allowed
  .registration-end
    grid-area: end
    align-self: center
    strong
      font-weight: bold
  .exchange
    grid-area: link
    align-self: center
    justify-self: end
    @include button-secondary()
  table
    grid-area: table

  tr
    .wrong, .right, .reserve
      font-weight: bold
    .wrong
      color: $c-danger
    .right
      color: $c-primary
    .reserve
      color: $c-warning

    .member
      padding: .5rem
      i.fa-times
        margin: 0 5px
        cursor: pointer
        &.disabled
          cursor: not-allowed
    .add_group
      display: flex
      .add .label
        @include button-primary()
        @include first-input()
      .addForeigner .label
        @include button-secondary()
        @include last-input()
      .label.disabled
          cursor: not-allowed
    .remove
      @include button-danger()
      &.disabled
        cursor: not-allowed
    
</style>
